import { BehaviorSubject }	from 'rxjs';
import { Component }        from '@angular/core';

import {
	AppState
}														from '../../';
import {
	ConfigService,
	StateService
}														from '../../service';

export interface HeaderWrapperState {
	search: boolean;
}

@Component({
  selector:			'electra-header-wrapper',
  styleUrls:		[ './headerWrapper.component.scss' ],
  templateUrl:	'./headerWrapper.component.html'
})
export class HeaderWrapperComponent {
  state:	HeaderWrapperState;

	desktopClass = '';

	get searchClass(): string {
    return (this.state.search || !this.configService.mobile ? '' : 'hide') + ' ' + this.desktopClass;
  }

	constructor(public configService: ConfigService, public stateService: StateService) {
		stateService.app.subscribe(data => { this.gotState(data); });

		this.desktopClass = configService.mobile ? '' : ' desktop';
	}

	gotState(state: HeaderWrapperState) {
		this.state = state;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/headerWrapper/headerWrapper.component.ts